import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import AdmissionSttConfigFields from './AdmissionSttConfigFields'

export const AdmissionSttConfigEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <AdmissionSttConfigFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default AdmissionSttConfigEdit
